module.exports = __webpack_public_path__ + "img/demo6-poster.548b5555.jpg";